import { render, staticRenderFns } from "./Cupoms.vue?vue&type=template&id=6c9fbb1e"
import script from "./Cupoms.vue?vue&type=script&lang=js"
export * from "./Cupoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports